import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import useUserIp from "hooks/useUserIp";
import { deleteEmptyObjects, fetchConfig } from "utils";

const useBooks = (queryParams) => {
	const { accessToken } = useTokenStore();
	const { userIp } = useUserIp();

	const fetch = async () => {
		const instance = await InitApi({ accessToken, userIp });
		const params = queryParams ? deleteEmptyObjects(queryParams) : null;

		const res = await instance.get(`books`, {
			params,
		});
		return res.data;
	};

	return useQuery(["books", queryParams], () => fetch(), {
		...fetchConfig,
	});
};

export default useBooks;
